import styled from 'styled-components';

export const DashboardHeaderContainer = styled.div.attrs({})`
  height: 60px;
  width: 100%;
  position: fixed;
  background: ${(props) => props.theme.palette.colors.white};
  padding: 0 25px 0 ${(props) => (props.opened ? '300px' : '25px')};
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: padding 0.3s ease;
`;

export const DashboardHeaderAction = styled.div.attrs({})`
  color: ${(props) => props.theme.palette.colors.white};
  font-size: 15px;
  text-transform: uppercase;
  cursor: pointer;
  margin-right: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DashboardHeaderActionIcon = styled.img.attrs({})`
  margin-right: 10px;
`;
